import axios from "axios";

const USER_SIGNATURE_SERVICE_BASE = `${process.env.REACT_APP_API_URL}/documentservice/api/userSignatures`;

const apiClient = axios.create({
  baseURL: USER_SIGNATURE_SERVICE_BASE,
  withCredentials: true,
});

// Add Authorization token to each request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

const userSignaturesService = {
  saveDrawSignature: (data) => {
    return apiClient.post("/draw", data);
  },

  saveTextSignature: (data) => {
    return apiClient.post("/text", data);
  },
  saveUploadSignature: (formData) => {
    return apiClient.post("/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getSignatures: (userId, signatureType) => {
    return apiClient.get("/getSignatures", {
      params: { userId, signatureType },
    });
  },
   getUploadedFile: (userId) => {
    return apiClient.get("/upload-file", {
      params: { userId },
      responseType: "blob", 
    });
  },
  getDrawSignatures: (userId) => {
  return apiClient.get("/draw-signatures", {
    params: { userId },
    responseType: "json", 
  });
},

softDeleteSignature : (userId,signatureType) =>{
  return apiClient.put("/soft-delete",null,{
    params :{userId,signatureType},
  
  })
},

};

export default userSignaturesService;
